import React from 'react';
import Loadable from 'react-loadable';
import { getPositions } from 'api';
import LoadableLoading from 'components/LoadableLoading';
import { loadReport } from './api';
import { IProps, ILoaded } from './interface';

export const path = '/subordinate-reports/:id';
export const getPath = (id: string) => `/subordinate-reports/${id}`;

const PageSubordinateReport: React.FC<IProps> = (props) => {
  const reportId = props.match.params.id;

  const loader = {
    page: () => import('./page'),
    i18n: () => import('./ru.json'),
    positions: getPositions,
  };

  if (reportId !== 'new') {
    // @ts-ignore
    loader.report = () => loadReport(reportId);
  }
  const LoadableMap = Loadable.Map({
    loader,
    loading: LoadableLoading,
    render(loaded: ILoaded, props: IProps): React.ReactNode {
      const Page = loaded.page.default;
      return <Page {...loaded} {...props} />;
    },
  });

  return <LoadableMap {...props} />;
};

export default PageSubordinateReport;
